<template>
    <div :title="alarm.message" class="alarm-icon-wrapper">
        <svg

             @click="openAlarmModal" class="alarm-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 117.36 104.32">

            <g id="Capa_2" data-name="Capa 2">
                <g id="Exclamation_marks" data-name="Exclamation marks">
                    <g id="Exclamation_mark_icon" data-name="Exclamation mark icon">
                        <g id="Shape">
                            <path class="cls-SenalReloj" d="M50,5A10,10,0,0,1,67.34,5L116,89.32a10,10,0,0,1-8.66,15H10a10,10,0,0,1-8.66-15Z"/>
                            <path class="cls-SenalReloj2" d="M10,99.32a5,5,0,0,1-4.33-7.51L54.35,7.5A5,5,0,0,1,63,7.5l48.68,84.32a5,5,0,0,1-4.33,7.5Z"/>
                            <path class="cls-SenalReloj" d="M10,95.32a1,1,0,0,1-.86-1.51L57.82,9.5a1,1,0,0,1,.86-.5,1,1,0,0,1,.87.5l48.68,84.32a1,1,0,0,1,0,1,1,1,0,0,1-.86.51Z"/>
                        </g>
                        <path id="Exclamation_mark" data-name="Exclamation mark" class="cls-SenalReloj2" d="M63.68,83.32a4.68,4.68,0,0,1-5,5,5,5,0,0,1,0-10A4.67,4.67,0,0,1,63.68,83.32Zm-5-54c-4.94,0-7.46,3.62-6.93,8.06h0l4,33.39h0a3,3,0,0,0,5.92,0h0l4-33.39h0C66.14,33,63.63,29.32,58.68,29.32Z"/>
                    </g>
                </g>
            </g>
        </svg>
    </div>
</template>

<script>
import {ProductionControlModals} from "../utils";
import {mapActions} from "vuex";

export default {
    name: "AlarmButton",
    props:{
        alarm: Object
    },
    methods:{
        ...mapActions('production_control', ['changeActiveModalState']),
        openAlarmModal(e){
            let self = this;
            e.stopPropagation();
            console.log(self.alarm)

            self.changeActiveModalState({modal:ProductionControlModals.ALARMS, data: self.alarm })

        }
    }
}
</script>